import { fetchWithAuth, urlBuilder } from "@/lib/api/utils";
import type { Citation } from "@/lib/api/types";

export async function getCitation(document_id: string, chunk_number: number): Promise<Citation> {
  return fetchWithAuth(urlBuilder(`/search/chunk/${document_id}/${chunk_number}`)).then((res) =>
    res.json()
  );
}
